
// @ts-nocheck

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';

// Thunk عام: يستقبل نوع واحد أو أكثر
// types: string | string[]
export const fetchLookup = createAsyncThunk(
  'Lookup2/fetchLookup',
  async (types, { rejectWithValue }) => {
    try {
      const typeArray = Array.isArray(types) ? types : [types];

      const result = {};

      // استدعاء لكل نوع لوحده بنفس الـ endpoint
      // Lookup/GetByTypes?LookupTypes=TYPE
      for (const type of typeArray) {
        if (!type) continue;
        const { data } = await ntxAPI.get(
          `Lookup/GetByTypes?LookupTypes=${encodeURIComponent(type)}`
        );
        // نخزن الداتا تحت اسم النوع
        result[type] = data;
      }

      return result; // مثال: { TITLE: [...], NATIONALITY: [...] }
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load lookup');
    }
  }
);

// قائمة/حقل واحد فقط للبيانات
const initialState = {
  data: {},   // { [type]: any[] }
  loading: false,
  error: null
};

const lookupSlice2 = createSlice({
  name: 'Lookup2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLookup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLookup.fulfilled, (state, action) => {
        state.loading = false;
        // ندمج النتائج الموجودة مع الجديدة
        state.data = {
          ...state.data,
          ...action.payload
        };
      })
      .addCase(fetchLookup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to load lookup';
      });
  }
});

export default lookupSlice2.reducer;
